import React, { useEffect, useState } from 'react';
import './Customization.css';
import placeHolderImage from "../../assets/placeholder.jpg";
import { getNewsData, updateNewsData, deleteNewsData } from '../../controllers/NewsController';
import { convertToBase64 } from '../../utils/Utils';
import { FaPlus, FaTrashAlt, FaRegSave } from "react-icons/fa";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import { IconButton } from "@mui/material";

function Customization() {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sectionTitle, setSectionTitle] = useState("");
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    getNewsData("projects").then((data) => {
      if (data) {
        setSectionTitle(data.title);
        if (data.projects.length > 0) {
          setProjects(data.projects);
        } else {
          setInitialProject();
      }}
      setIsLoading(false);
    });
  }, []);

  const updateProjects = () => {
    const [isValid, errorMessage] = validateFormat();
    if (isValid) {
      const data = { title: sectionTitle, projects: projects };
      console.log(data);
      updateNewsData("projects", data).catch((error) => {
        console.error('Error updating projects data:', error);
      }).finally(() => {
        setHasUnsavedChanges(false);
      });
    } else {
      setErrorMessage(errorMessage);
    }
  };

  const deleteProject = () => {
    deleteNewsData("projects", currentPage).then((data) => {
      const newProjects = [...projects];
      newProjects.splice(currentPage, 1);
      if (newProjects.length === 0) {
        setInitialProject();
      } else {
        setProjects(newProjects);
      }
      setCurrentPage(0);
      setHasUnsavedChanges(false);
    })
  }

  const validateFormat = () => {
    const projectToValidate = projects[currentPage];
    if (projectToValidate.imageBase64 === placeHolderImage) return [false, "Erreur: Une image est requise."];
    else if (!projectToValidate.url) return [false, "Erreur: Un URL est requis."];
    else if (!projectToValidate.title) return [false, "Erreur: Un titre est requis."];
    return [true, undefined];
  }

  const setInitialProject = () => {
    const newProject = { title: "Nouveau projet", imageBase64: placeHolderImage, url: "" };
    setProjects([newProject]);
  }

  const addNewProject = () => {
    const newProject = { title: "Nouveau projet", imageBase64: placeHolderImage, url: "" };
    setProjects([...projects, newProject]);
    setCurrentPage(projects.length);
    setHasUnsavedChanges(true);
  };

  const updateTitle = (title) => {
    const newProjects = [...projects];
    newProjects[currentPage].title = title;
    setProjects(newProjects);
    setErrorMessage("");
    setHasUnsavedChanges(true);
  };

  const updateLink = (link) => {
    const newProjects = [...projects];
    newProjects[currentPage].url = link;
    setProjects(newProjects);
    setErrorMessage("");
    setHasUnsavedChanges(true);
  };

  const updateImage = (image) => {
    const newProjects = [...projects];
    convertToBase64(image).then((base64) => {
      newProjects[currentPage].imageBase64 = base64;
      setProjects(newProjects);
      setErrorMessage("");
      setHasUnsavedChanges(true);
    })

  };

  const handlePageChange = (index) => {
    setCurrentPage(index);
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (!isLoading && projects.length === 0) {
    addNewProject();
  }

  return (
    <div className='page-container'>
      <h1 className="page-title">Projets</h1>
      <div className="card-container">
        <h2 className="card-title">{sectionTitle}</h2>
        <div className="card-text-input">
          <span className="text-label">Titre:</span>
          <input
            type="text"
            className="input-text"
            value={projects[currentPage].title}
            onChange={(e) => updateTitle(e.target.value)}
          />
        </div>
        <img src={projects[currentPage].imageBase64} alt="Project" className="card-image" />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => updateImage(e.target.files[0])}
          style={{ display: "none" }}
          id="imageUpload"
        />
        <label htmlFor="imageUpload" className="card-button">Modifier l'image</label>
        <div className="card-text-input">
          <span className="text-label">URL:</span>
          <input
            type="text"
            className="input-text"
            value={projects[currentPage].url}
            onChange={(e) => updateLink(e.target.value)}
          />
        </div>
        {errorMessage.length !== 0 && <p className="error-message">{errorMessage}</p>}
        <div className="card-footer">
          <div className="footer-options">
            <button className="card-button footer-option" disabled={hasUnsavedChanges} onClick={() => addNewProject()} >
              <FaPlus />
            </button>
            <button className="card-button footer-option" disabled={!hasUnsavedChanges} onClick={() => updateProjects()}>
              <FaRegSave />
            </button>
            <button className="card-button footer-option" onClick={() => deleteProject()}>
              <FaTrashAlt />
            </button>
          </div>
          <div className="pagination-container">
            <IconButton disabled={currentPage === 0} onClick={() => handlePageChange(currentPage - 1)}>
              <MdNavigateBefore className="navigation-arrow" />
            </IconButton>
            {projects.map((_, index) => (
              <button
                key={index}
                disabled={hasUnsavedChanges}
                onClick={() => handlePageChange(index)}
                className={`pagination-circle ${currentPage === index ? "active" : ""
                  }`}
              />
            ))}
            <IconButton disabled={currentPage === projects.length - 1} onClick={() => handlePageChange(currentPage + 1)}>
              <MdNavigateNext className="navigation-arrow" />
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Customization;
